import { FC, useMemo } from "react";
import { ColumnConfig, TextAlignment, wafflesKeyColumnName } from "@app/shared/waffles";
import { Waffles } from "@app/shared/waffles/Waffles";
import { WafflesThemes } from "@app/shared/waffles/exports";
import { LineOfBusinessData } from "../interfaces";
interface NetworkTaxonomyLOBTableData {
  [wafflesKeyColumnName]: string;
  exceptions: string;
  fillableGaps: string;
  gapPercent: string;
  gaps: string;
  lineOfBusiness: string;
  medianGapAge: string;
}

const columnConfig: ColumnConfig = {
  counties: {
    alignment: TextAlignment.Right,
    displayText: "Counties",
    noSort: true,
    testId: "counties",
  },
  exceptions: {
    alignment: TextAlignment.Right,
    displayText: "Approved Exceptions",
    noSort: true,
    testId: "exceptions",
  },
  fillableGaps: {
    alignment: TextAlignment.Right,
    displayElement: <>Composite<br />Fillable Gaps</>,
    noSort: true,
    testId: "fillable-gaps",
    tooltip: "",
  },
  gapPercent: {
    alignment: TextAlignment.Right,
    displayText: "Gap Percent",
    noSort: true,
    testId: "gap-percent",
  },
  gaps: {
    alignment: TextAlignment.Right,
    displayText: "Gaps",
    noSort: true,
    testId: "gaps",
  },
  lineOfBusiness: {
    alignment: TextAlignment.Left,
    displayText: "Line of Business",
    noSort: true,
    testId: "line-of-business",
  },
  medianGapAge: {
    alignment: TextAlignment.Right,
    displayElement: <>Median<br />Gap Age Days</>,
    noSort: true,
    testId: "median-gap-age",
    // displayElement defaults to the displayText/key for a tooltip, but we don't want it
    tooltip: "",
  },
};

interface LineOfBusinessTableProps {
  tableData: LineOfBusinessData[];
}

const LineOfBusinessTable: FC<LineOfBusinessTableProps> = (props: LineOfBusinessTableProps) => {

  /* oxlint-disable sort-keys */
  const tableRows: NetworkTaxonomyLOBTableData[] = useMemo(() => {
    return (props.tableData || []).map((lob) => {
      return {
        [wafflesKeyColumnName]: lob.networkTaxonomyLOB,
        lineOfBusiness: lob.networkTaxonomyLOB,
        gaps: lob.gapCount.toLocaleString(),
        fillableGaps: lob.compositeFillableGapCount.toLocaleString(),
        medianGapAge: lob.medianGapAge.toLocaleString(),
        gapPercent: `${lob.gapPercent.toLocaleString()}%`,
        counties: lob.countyCount.toLocaleString(),
        exceptions: lob.approvedExceptionCount.toLocaleString(),
      };
    })
  }, [props.tableData]);
  /* oxlint-enable */

  const rowDecorator = (row: NetworkTaxonomyLOBTableData) => {
    if (row.lineOfBusiness === "Total") {
      return "footer";
    }
  }

  return (
    <div className="qes-dashboard-tile__table">
      <Waffles<NetworkTaxonomyLOBTableData>
        columns={columnConfig}
        data={tableRows}
        disableStickyHeader={true}
        fullWidth={true}
        keyColumns={["lineOfBusiness"]}
        testId="line-of-business-overview"
        rowDecorator={rowDecorator}
        theme={WafflesThemes.Simple}
      />
    </div>
  )
}

export default LineOfBusinessTable;